import React, { useContext } from "react";
import { ErrorBoundary, Page } from "@sscs/ui";
import { convertFinalCheckLabel } from "../../utils";
import { ReportContext } from "../context";
import { useGetReportSummaryQuery } from "../services/shared.api";
import Cards from "./Cards";
import ComponentAgeTimeline from "./componentAgeTimeline/ComponentAgeTimeline";
import Issues from "./issues/Issues";
import Levels from "./levels/Levels";
import Malware from "./malware/Malware";
import PerformedChecks from "./performedChecks/PerformedChecks";
import RiskAssessment from "./riskAssessment/RiskAssessment";
import RiskCards from "./riskCards/RiskCards";
import styles from "./sdlcSummaryStyles.module.scss";
import Vulnerabilities from "./vulnerabilities/Vulnerabilities";
const ReportSummary = () => {
    const { reportId, diffId, selectedCheck } = useContext(ReportContext);
    const { data: summary } = useGetReportSummaryQuery({
        diff_report_id: diffId,
        ui_id: reportId,
    });
    const scanReport = summary === null || summary === void 0 ? void 0 : summary.checks_report.report.scans[selectedCheck];
    if (!summary || !scanReport)
        return null;
    const { isRepro } = convertFinalCheckLabel(scanReport.checks);
    const showLevels = scanReport.inhibitors.scan_level > 0 && !isRepro;
    return (React.createElement(Page.Root, null,
        React.createElement(Page.Body, { className: styles["summary-container"] },
            React.createElement(ErrorBoundary, { key: "summary-cards" },
                React.createElement(Cards, { summary: summary })),
            React.createElement(ErrorBoundary, { key: "risk-assessment" },
                React.createElement(RiskAssessment, { risk: scanReport.assessments, disabledPoliciesCount: summary.analysis_summary.issues.disabled_count })),
            React.createElement(ErrorBoundary, { key: "levels" }, showLevels ? (React.createElement(Levels, { inhibitors: scanReport.inhibitors, statistics: summary.analysis_summary.policy_statistics })) : null),
            React.createElement(ErrorBoundary, { key: "performed-checks" },
                React.createElement(PerformedChecks, { scans: summary.checks_report.report.scans })),
            React.createElement(ErrorBoundary, { key: "issues" },
                React.createElement(Issues, { issues: summary.analysis_summary.issues, policyStatistics: summary.analysis_summary.policy_statistics })),
            React.createElement(ErrorBoundary, { key: "component-age-timeline" },
                React.createElement(ComponentAgeTimeline, { timeline: summary.analysis_summary.timelines })),
            React.createElement(ErrorBoundary, { key: "vulnerabilities" },
                React.createElement(Vulnerabilities, { vulnerabilities: summary.analysis_summary.vulnerabilities, vulnerabilityStatistics: scanReport.statistics.vulnerabilities })),
            React.createElement(ErrorBoundary, { key: "malware" },
                React.createElement(Malware, { detections: summary.analysis_summary.detections })),
            React.createElement(RiskCards, { riskAssessment: scanReport.assessments, policyCountByRisk: summary.analysis_summary.policy_count_by_risk }))));
};
export default ReportSummary;
//# sourceMappingURL=ReportSummary.js.map